import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

// Guard que restringe el acceso a /loginunita solo en environments FGAU. 16/07/2025
@Injectable({
  providedIn: 'root'
})
export class LoginUnitaGuard implements CanActivate {

  // Ambientes donde /loginunita es accesible
  private allowedAmbientes = [
    'devfactorajeau',
    'testfactorajeau',
    'prodfactorajeau',
    'testfactoraje',
    'prodfactoraje'
  ];

  constructor(private router: Router) {}

  canActivate(): boolean {
    const ambiente = environment.Ambiente.toLowerCase();
    if (this.allowedAmbientes.includes(ambiente)) {
      return true;
    }
    // Si no es un ambiente permitido, redirigir a la página 404
    this.router.navigate(['/accesodenegado']);
    return false;
  }
}
